import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { SkeletonMatchesListComponent } from '@/app/components/shared/skeleton';
import { MatchFavoriteService } from '@/app/services/favorite';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatchFavoriteItemComponent } from '../../components';

@Component({
  selector: 'app-my-matches',
  standalone: true,
  imports: [
    MatchFavoriteItemComponent,
    SkeletonMatchesListComponent,
    NoResultComponent,
  ],
  templateUrl: './my-matches.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyMatchesComponent {
  private matchFavoriteService = inject(MatchFavoriteService);

  isLoading = computed(() =>
    this.matchFavoriteService.isLoadingMatchesFavorites()
  );

  myMatches = computed(
    () => this.matchFavoriteService.matchesFavorites()?.Matches ?? []
  );
}
